
<template>
    <div>
        <h3 class="mb-3">Membership</h3>
        <div class="row mb-4">
            <div class="col-md-3">
                <div class="card color-palette mb-4">
                    <div class="card-header color-palette__header">
                        <div class="color-palette__colors">
                            <div class="color-palette__color--blue h-color--black">65BAF5</div>
                            <div class="color-palette__color--blue-dark">034A80</div>
                        </div>
                    </div>
                    <div class="card-body">
                        Blue
                        <div class="small text-danger d-flex justify-content-between align-items-center"><code>$phd-blue</code>  <code>$phd-blue-alt</code></div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card color-palette mb-4">
                    <div class="card-header color-palette__header">
                        <div class="color-palette__colors">
                            <div class="color-palette__color--mustard">F9B146</div>
                            <div class="color-palette__color--mustard-dark h-color--black">A7762D</div>
                        </div>
                    </div>
                    <div class="card-body">
                        Mustard
                        <div class="small text-danger d-flex justify-content-between align-items-center"><code>$phd-mustard</code>  <code>$phd-mustard-alt</code></div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card color-palette mb-4">
                    <div class="card-header color-palette__header">
                        <div class="color-palette__colors">
                            <div class="color-palette__color--lime">ABD02E</div>
                            <div class="color-palette__color--lime-dark">687F1A</div>
                        </div>
                    </div>
                    <div class="card-body">
                        Lime
                        <div class="small text-danger d-flex justify-content-between align-items-center"><code>$phd-lime</code>  <code>$phd-lime-alt</code></div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="card color-palette mb-4">
                    <div class="card-header color-palette__header">
                        <div class="color-palette__colors">
                            <div class="color-palette__color--seafoam">55D2BF</div>
                            <div class="color-palette__color--seafoam-dark">1D7164</div>
                        </div>
                    </div>
                    <div class="card-body">
                        Seafoam
                        <div class="small text-danger d-flex justify-content-between align-items-center"><code>$phd-seafoam</code>  <code>$phd-seafoam-alt</code></div>
                    </div>
                </div>
            </div>
        </div>
        <h3 class="component__heading mb-3">Borders</h3>
        <div class="row mb-4">
            <div class="col-md-3">
                <div class="card color-palette mb-4">
                    <div class="card-header color-palette__header">
                        <div class="color-palette__colors">
                            <div class="color-palette__color--gray-border text-uppercase">dee2e6</div>
                            <div class="color-palette__color--red-border">034A80</div>
                        </div>
                    </div>
                    <div class="card-body">
                        Border
                        <div class="small text-danger d-flex justify-content-between align-items-center"><code>$gray-300</code>  <code>$phd-red</code></div>
                    </div>
                </div>
            </div>
        </div>

        <h3 class="component__heading mb-3">Text Colors (Passed Color Contrast Ratio)</h3>

        <div class="row mb-4" v-if="!isFetching">
            <div class="col-md-3" v-for="(color, index) in colors" :key="index">
                <div class="c-text-color-card">
                    <div class="card phd-box-shadow my-3">
                        <div class="card-body">
                            <div class="small text-danger d-flex justify-content-between align-items-center text-lowercase"><code>{{'.h-color--'+color}}</code></div>
                            <div class="section__label">Recent News</div>
                            <h4 :class='"mb-4 h-color--"+color'>{{headlines[Math.floor(Math.random() * headlines.length)]}}</h4>
                            <p class="news-list__desc small h-color--gray-dark text-capitalize">Atrial fibrillation (AF) is the most common cardiac arrhythmia...</p>
                            <hr class="w-100 mt-auto">
                            <a href="#" class="text-left c-cta c-cta--arrow h-theme--red">View More</a>
                            
                        </div>
                    </div>
                </div>
            </div>    
        </div>

        <div class="row mb-4" v-if="!isFetching">
            <div class="col-md-3" v-for="(color, index) in cardsamplecolors" :key="index">
                <div class="c-text-color-card">
                    <div class="card phd-box-shadow my-3">
                        <div class="card-body pt-3">
                            
                            <div class="small text-danger d-flex justify-content-between align-items-center text-lowercase"><code>{{'.h-color--'+color}}</code></div>
                            <div class="d-flex">
                                <img :src="users[index].avatars[0].url" class="p-1 mr-2 thumbnail rounded-circle">
                                <div class="message">
                                    <div class="mb-0 news-list__title text-capitalize" :class='"h-color--"+color'><span>{{users[index].first_name}}</span> <span>{{users[index].last_name}}</span></div>
                                    <p class="news-list__byline h-color--black text-capitalize">Lorem ipsum, dolor.</p>
                                </div>
                            </div>
                            <!-- <img :src="users[Math.floor(Math.random() * users.length)].avatars[0].url" class="rounded-circle" /> -->
                             <h4 :class='"mt-auto mb-1 h-color--"+color'>{{headlines[Math.floor(Math.random() * headlines.length)]}}</h4>
                             <p class="news-list__desc small h-color--gray-dark text-capitalize">Atrial fibrillation (AF) is the most common cardiac arrhythmia...</p>
                            <hr class="w-100 mt-auto">
                            <a href="#" class="text-left c-cta c-cta--arrow h-theme--red">View More</a>
                            
                        </div>
                    </div>
                </div>
            </div>    
        </div>


    </div>
</template>

<style lang="scss" scoped>
     @import "~@/sass/base";

    .thumbnail {
        width: 64px;
        height: 64px;
        object-fit: cover;
    }
    
    .card {
        border-radius: 6px;
        border: 0;

        .card-body {
            color: $phd-gray;
            padding-top: 4px;
            text-transform: uppercase;
            font-size: 0.85rem;

            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .color-palette {
        box-shadow: $aha-box-shadow;
        letter-spacing: 1px;

        &__header {
            // padding: 5px;
            border: 0;
            background-color: transparent;

        }

        &__colors {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            overflow: hidden;
            font-size: 14px;

            & > * {
                flex: 1;
                text-align: center;
                color: #fff;
                padding: 34px 0;
            }
        }

        &__color {
            &--gray-border {
                background-color: $gray-300;
                color: $phd-black-alt;
            }

             &--red-border {
                background-color: $phd-red;
                color: #FFF;
            }

            &--blue {
                background: $phd-blue;
            }

            &--blue-dark {
                background: $phd-blue-alt;
            }

            &--mustard {
                background: $phd-mustard;
                color: $phd-gray--darker;
            }

            &--mustard-dark {
                background: $phd-mustard-alt;
            }
            &--lime {
                background: $phd-lime;
                color: $phd-gray--darker;
            }
            &--lime-dark {
                background: $phd-lime-alt;
            }

            &--seafoam {
                background: $phd-seafoam;
                color: $phd-gray--darker;
            }

            &--seafoam-dark {
                background: $phd-seafoam-alt;
            }

           
        }
    }

    .c-text-color-card .card {
        height: 340px;
    }

    .news-list__byline, .news-list__desc {
        font-weight: 500;
    }
</style>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            isFetching: true,
            users: [],
            tu: [
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                {'name': 'Tu'},
                {'name': 'Leon'},
                {'name': 'Clinton'},
                
            ],
            colors: [
                'red',
                'red-alt',
                'black',
                'black-alt',
                'gray-mid',
                'gray-dark',
                'blue-alt',
                'lime-alt',
                'seafoam-alt'
            ],
            cardsamplecolors: [
                'red-alt',
                'black-alt',
                'gray-dark',
                'blue-alt',
            ],
            headlines: [
                "What To Expect From This Year's Event",
                "Professional Partnership",
                "Compassion Amid Crisis",
                "What To Expect From This Year's Event",
                "Compassion Amid Crisis",
            ]
        }
    },
    methods: {
        fetchUsers() {
            axios
                .get('https://tinyfac.es/api/users')
                .then(response => {
                    this.users = response.data
                    // window.__users__ = this.users;
                    this.isFetching = false
                    })
                .catch(error => console.log(error))    
        }
    },
    created() {
        this.fetchUsers();
        // console.log(this.users)
    }
}
</script>


// WEBPACK FOOTER //
// demo/ui-kit/phd/phd-color-palette-membership.vue